import _ from 'lodash'
import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'


// import { Link } from 'react-router';
import { Table, Button } from 'semantic-ui-react'

const getButtonGroup = (service, actions, doing) => {
  let buttons = []
  if (service.enabled) {
    buttons.push(<Button key={'disable'} loading={doing.disable} negative icon={'ban'} onClick={actions.disable} />)
    if(service.running) {
      buttons.push(<Button key={'stop'} loading={doing.stop} icon={'stop'} onClick={actions.stop} />)
      buttons.push(<Button key={'restart'} loading={doing.restart} icon={'refresh'} onClick={actions.restart} />)
    } else {
      buttons.push(<Button key={'start'} loading={doing.start} icon={'play'} onClick={actions.start} />)
    }
  } else {
    buttons.push(<Button key={'enable'} loading={doing.enable} positive icon={'sun'} onClick={actions.enable} />)
  }
  return <Button.Group size={'mini'}>{buttons}</Button.Group>
}


const ServiceRow = (props) => {
  const { actions, service, doing } = props
  return (
    <Table.Row>
      <Table.Cell>{service.name}</Table.Cell>
      <Table.Cell>{getButtonGroup(service, actions, doing)}</Table.Cell>
    </Table.Row>
  )
}
ServiceRow.displayName = 'ServiceRow'
ServiceRow.propTypes = {
  service: PropTypes.object.isRequired,
  actions: PropTypes.shape({
    enable: PropTypes.func.isRequired,
    disable: PropTypes.func.isRequired,
    start: PropTypes.func.isRequired,
    restart: PropTypes.func.isRequired,
    stop: PropTypes.func.isRequired,
  }).isRequired,
  doing: PropTypes.shape({
    enable: PropTypes.bool.isRequired,
    disable: PropTypes.bool.isRequired,
    start: PropTypes.bool.isRequired,
    restart: PropTypes.bool.isRequired,
    stop: PropTypes.bool.isRequired,
  }).isRequired,
}
ServiceRow.defaultProps = {
  doing: {
    enable: false,
    disable: false,
    start: false,
    restart: false,
    stop: false,
  }
}

export default class ServicesTable extends PureComponent {
  static propTypes = {
    mid: PropTypes.string.isRequired,
    services: PropTypes.object.isRequired,
    actions: PropTypes.shape({
      enable: PropTypes.func.isRequired,
      disable: PropTypes.func.isRequired,
      start: PropTypes.func.isRequired,
      restart: PropTypes.func.isRequired,
      stop: PropTypes.func.isRequired,
    }).isRequired
  }
  state = {
    doing: {}
  }

  render () {
    const {mid, services, actions } = this.props
    return (
      <Table>
        <Table.Body>
          {_(services)
            .toPairs()
            .filter(([name]) => (!name.endsWith('@')))
            .map(([k, v]) => (
              <ServiceRow
                key={`service--${k}`}
                service={_.extend({}, {name: k}, v)}
                actions={_(actions)
                  .map(
                    (action, actionName) => ([
                      actionName,
                      () => {
                        this.setState({
                          doing: {
                            ...this.state.doing,
                            [k]:{[actionName]: true}
                          }
                        })
                        return action(mid, k).then(
                          () => this.setState({
                            doing: {
                              ...this.state.doing,
                              [k]: {[actionName]: false}
                            }
                          })
                        )
                      }
                    ])
                  )
                  .fromPairs()
                  .value()
                }
                doing={_
                  .extend(
                    {enable: false, disable: false, start: false, restart: false, stop: false},
                    this.state.doing[k] || {})
                }
              />
            ))
            .value()
          }
        </Table.Body>
      </Table>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/minions/ServicesTable.js